import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { FilterFormulaGroup } from "../models/filters/filter-formula-group";
import { FormulaGroup } from "../models/formulas/formula-group";


@Injectable({
  providedIn: 'root'
})
export class FormulaGroupService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/formulasGroup'; 

  findAllPageableFormulaGroup(filterFormulaGroup: FilterFormulaGroup, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterFormulaGroup);
  }

  findFormulaGroupById(id: number): Observable<FormulaGroup> {
    return this.http.get<FormulaGroup>(`${this.url}/${id}`);
  }

  createFormulaGroup(formulaGroup: FormulaGroup): Observable<FormulaGroup>{
    return this.http.post<FormulaGroup>(this.url, formulaGroup);
  }

  updateFormulaGroup(formulaGroup: FormulaGroup): Observable<FormulaGroup>{
    return this.http.put<FormulaGroup>(`${this.url}/${formulaGroup.id}`, formulaGroup);
  }

}